import React, { useState } from 'react';
import chLeft from '../../images/icon_chevron_left.svg';
import chRight from '../../images/icon_chevron_right.svg';
import { isEmptyObject } from '../../core/util';
import styles from './RiskRewardModal.css';

import { getRRDisplay } from '../RiskReward/util';
import { MFBeaconModal } from '../Beacon/BeaconComponents';

export const SubTitle = ({ fund, rrDisplay, displaySubTitle }) => {
  if (!displaySubTitle) return null;

  return (
    <div className="mb-2">
      <div className="modal-subtitle mb-1">{`${fund.name} (${fund.ticker})`}</div>
      <div className="modal-subtitle-caption">{`${rrDisplay.label} - ${rrDisplay.category}`}</div>
      <style jsx>{styles}</style>
    </div>
  );
};

const RiskRewardModal = ({ riskLevel = 240, fund }) => {
  const [currentRiskLevel, setCurrentRiskLevel] = useState(null);

  const rrDisplay = !currentRiskLevel
    ? getRRDisplay(riskLevel)
    : getRRDisplay(currentRiskLevel);

  const scrollDir = (dir, level) => {
    if (dir === 'prev') {
      setCurrentRiskLevel(level === 200 ? 290 : level - 10);
    } else {
      setCurrentRiskLevel(level === 290 ? 200 : level + 10);
    }
  };
  const displaySubTitle = !isEmptyObject(fund) && !currentRiskLevel;

  const modalTitle = 'Risk Potential';

  return (
    <>
      <MFBeaconModal id="riskRewardModal">
        <div className="beacon-modal__title">{modalTitle}</div>
        <div className="risk-reward-modal">
          <SubTitle
            fund={fund}
            rrDisplay={rrDisplay}
            displaySubTitle={displaySubTitle}
          />

          <div className="qv-row mb-6">
            Click through the risk/reward spectrum to learn more about each
            range.
          </div>

          <div className="qv-row">
            <div className="qv-col">Lower</div>
            <div className="qv-col">Moderate</div>
            <div className="qv-col">Higher</div>
          </div>

          <div className="qv-row">
            <div className="gradient-range">
              {/* left arrow */}
              <div className="gradient-arrows left-arrow inline-block">
                <i
                  data-name="leftArrowLink"
                  onClick={() =>
                    scrollDir(
                      'prev',
                      !currentRiskLevel ? riskLevel : currentRiskLevel
                    )
                  }
                  onKeyPress={() =>
                    scrollDir(
                      'prev',
                      !currentRiskLevel ? riskLevel : currentRiskLevel
                    )
                  }
                  role="link"
                  tabIndex="-1">
                  <img src={chLeft} alt="left arrow" height="50px" />
                </i>
              </div>

              <div className="gradient-image inline-block">
                <div className={`rr-graph-row rr-graph-top rrg-${riskLevel}`}>
                  {' '}
                </div>
                <div
                  className={`rr-graph-row rr-graph rrg-${
                    !currentRiskLevel ? riskLevel : currentRiskLevel
                  }`}>
                  {' '}
                </div>
                <div
                  className={`rr-graph-row rr-graph-bottom rrg-${riskLevel}`}>
                  {' '}
                </div>
              </div>

              {/* right arrow */}
              <div className="gradient-arrows right-arrow inline-block">
                <i
                  data-name="rightArrowLink"
                  onClick={() =>
                    scrollDir(
                      'next',
                      !currentRiskLevel ? riskLevel : currentRiskLevel
                    )
                  }
                  onKeyPress={() =>
                    scrollDir(
                      'next',
                      !currentRiskLevel ? riskLevel : currentRiskLevel
                    )
                  }
                  role="link"
                  tabIndex="-1">
                  <img src={chRight} alt="right arrow" height="50px" />
                </i>
              </div>
            </div>
          </div>

          <div className="qv-row mb-6">{rrDisplay.label}</div>

          <div className="qv-row">
            <p>
              The standard deviation range for this risk potential category is{' '}
              {rrDisplay.label}. See the accompanying disclosure for more
              information about how the standard deviation of each fund is
              calculated for placement in this risk return spectrum.
            </p>
          </div>
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default RiskRewardModal;
